import React, { lazy } from 'react'
import {
  unstable_HistoryRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom'
import { createBrowserHistory } from 'history'

import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'

import routes from 'constants/routes'

import MainWrapper from 'components/wrappers/MainWrapper'

import NotFound from 'screens/NotFound'
import InitModals from 'components/modals/InitModals'

const Resources = lazy(() => import('screens/Resources'))
const Login = lazy(() => import('screens/Login'))
const ForgotPassword = lazy(() => import('screens/ForgotPassword'))
const ResetPassword = lazy(() => import('screens/ResetPassword'))
const Profile = lazy(() => import('screens/Profile'))
const Campaigns = lazy(() => import('screens/Campaigns'))
const Campaign = lazy(() => import('screens/Campaign'))
const Registration = lazy(() => import('screens/Registration'))
const Verification = lazy(() => import('screens/Verification'))
const AcceptanceForm = lazy(() => import('screens/Forms/AcceptanceForm'))
const SubmissionForm = lazy(() => import('screens/Forms/SubmissionForm'))

const history = createBrowserHistory()

const AppRoutes = () => {
  return (
    // @ts-expect-error Because of type mismatches, does not impact functionality
    <Router history={history}>
      <Routes>
        <Route
          path={routes.login}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path={routes.resetPassword}
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path={routes.registration}
          element={
            <PublicRoute>
              <Registration />
            </PublicRoute>
          }
        />
        <Route
          path={routes.verification}
          element={
            <PublicRoute>
              <Verification />
            </PublicRoute>
          }
        />
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <MainWrapper />
            </PrivateRoute>
          }
        >
          <Route path={routes.campaigns.root}>
            <Route index element={<Campaigns />} />
            <Route path={routes.campaigns.campaign}>
              <Route index element={<Campaign />} />
              <Route
                path={routes.campaigns.interest}
                element={<AcceptanceForm />}
              />
              <Route
                path={routes.campaigns.submission}
                element={<SubmissionForm />}
              />
            </Route>
          </Route>
          <Route path={routes.profile.root}>
            <Route index element={<Profile />} />
          </Route>
          <Route path={routes.resources.root} element={<Resources />} />
        </Route>
        <Route path={routes.pageNotFound} element={<NotFound />} />
        <Route
          path="*"
          element={<Navigate to={routes.pageNotFound} replace />}
        />
      </Routes>
      <InitModals />
    </Router>
  )
}

export default AppRoutes
